export const IMAGE = "image";
export const VIDEO = "video";

const MediaType = { IMAGE, VIDEO };
export default MediaType;
